// extracted by mini-css-extract-plugin
export var text = "_5l-0";